import { Search } from 'lucide-react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'ui/components/Button';

interface SearchButtonProps {
  onToggle: () => void;
}

export const SearchButton: React.FC<SearchButtonProps> = ({ onToggle }) => {
  const menuRef = useRef(null);
  const { t } = useTranslation();

  return (
    <Button
      leftIcon={<Search size={18} />}
      size="icon"
      variant="ghost"
      onClick={onToggle}
      ref={menuRef}
      toolTipPortal
      tooltip={t('search_button.tooltip', 'Search tasks and comments in real-time')}
    />
  );
};